"use client";

import { useState } from "react";
import Link from "next/link";
import { useIntl } from "react-intl";


export default function Questions({ whatsappNumber = "" }) {
  const [openIndex, setOpenIndex] = useState(null); // No item open by default

  const intl = useIntl();

  const accordionItems = [
    {
      title: intl.formatMessage({
        id: "questions.item1.title",
        defaultMessage: "Who will I talk to after I reach out?",
      }),
      content: intl.formatMessage({
        id: "questions.item1.answer",
        defaultMessage: "A real member of the Fitsib team — not a bot or scripted call.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item2.title",
        defaultMessage: "Do I need medical reports before contacting Fitsib?",
      }),
      content: intl.formatMessage({
        id: "questions.item2.answer",
        defaultMessage: "Reports help, but you can reach out even if you don't have them yet.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item3.title",
        defaultMessage: "Will you push a doctor, hospital, or treatment?",
      }),
      content: intl.formatMessage({
        id: "questions.item3.answer",
        defaultMessage: "No. Our guidance is patient-first and unbiased.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item4.title",
        defaultMessage: "What if we are already consulting a doctor?",
      }),
      content: intl.formatMessage({
        id: "questions.item4.answer",
        defaultMessage: "That's completely fine. We can help you understand options or get another perspective.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item5.title",
        defaultMessage: "Will you rush us to start treatment or surgery?",
      }),
      content: intl.formatMessage({
        id: "questions.item5.answer",
        defaultMessage: "No. Decisions are always made at your pace.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item6.title",
        defaultMessage: "Do you charge patients or families?",
      }),
      content: intl.formatMessage({
        id: "questions.item6.answer",
        defaultMessage: "No. Fitsib does not charge for guidance or coordination.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item7.title",
        defaultMessage: "What if we are unsure about the treatment ?",
      }),
      content: intl.formatMessage({
        id: "questions.item7.answer",
        defaultMessage: "That’s completely normal. We explain the options in simple language so you can decide with confidence.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item8.title",
        defaultMessage: "What if we need time to decide?",
      }),
      content: intl.formatMessage({
        id: "questions.item8.answer",
        defaultMessage: "You can decide at your own pace. We provide support and information — you choose what feels right for your family.",
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item9.title",
        defaultMessage: "What if treatment requires travel?"
      }),
      content: intl.formatMessage({
        id: "questions.item9.answer",
        defaultMessage: "We stay with you throughout the journey"
      }),
    },
    {
      title: intl.formatMessage({
        id: "questions.item10.title",
        defaultMessage: "Where is our medical information shared?"
      }),
      content: intl.formatMessage({
        id: "questions.item10.answer",
        defaultMessage: "Your privacy is respected at every step"
      }),
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const whatsappLink = whatsappNumber
    ? `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=Hello,%20I%20would%20like%20to%20talk%20to%20the%20Fitsib%20team,%20Thank%20you!`
    : "https://api.whatsapp.com/send?phone=&text=Hello,%20I%20would%20like%20to%20talk%20to%20the%20Fitsib%20team,%20Thank%20you!";

  return (
    <>
      <style>{`
        .questions-section-bg {
          // background-image: url("/images/Questions%20Rectangle.svg");
          // background-repeat: no-repeat;
          // background-size: cover;
          // background-position: center;
          background-color: #FBFDFF
          margin-top: -10px;
        }
        @media (max-width: 768px) {
          .questions-section-bg {
            // 
            background-color: #FBFDFF
            margin-top: -6px;
          }
          .questions-headline {
            font-size: 24px !important;
            line-height: 32px !important;
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 8px !important;
          }
          .questions-headline span {
            display: inline !important;
            white-space: normal !important;
            word-break: break-word !important;
          }
        }
        .questions-cta-wrapper {
          display: flex;
          justify-content: center;
          margin-top: 16px;
        }
        .questions-cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          font-family: "Roboto", sans-serif;
          font-size: 14px;
          font-weight: 600;
          color: #00428A;
          background: #FFFFFF;
          padding: 12px 32px;
          border-radius: 25px;
          border: 1px solid #00428A;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        .questions-cta:hover {
          background: #00428A;
          color: #FFFFFF;
          border-color: #00428A;
        }
        @media (max-width: 768px) {
          .questions-cta {
            width: 100%;
            max-width: 280px;
            justify-content: center;
            padding: 12px 40px;
          }
        }
      `}</style>
      <section className="questions-section-bg">
        <div
          style={{
            maxWidth: "750px",
            margin: "0 auto",
            padding: "10px 10px 40px",
          }}
        >
          <h2
            className="questions-headline"
            style={{
              fontFamily: '"Roboto Slab", serif',
              fontWeight: 300,
              fontSize: "40px",
              lineHeight: "48px",
              letterSpacing: "0.04em",
              // margin: "0 auto 32px auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              verticalAlign: "middle",
              flexWrap: "wrap",
              textAlign: "center",

            }}
          >
            <span style={{ marginRight: "8px", whiteSpace: "nowrap" }}>
              {intl.formatMessage({
                id: "questions.headingPart1",
                defaultMessage: "Questions",
              })}
            </span>
            <span
              style={{
                fontWeight: 700,
                color: "#00428A",
                lineHeight: "48px",
                whiteSpace: "nowrap",
              }}
            >
              {intl.formatMessage({
                id: "questions.headingPart2",
                defaultMessage: "You May Be Carrying",
              })}
            </span>
          </h2>

          <h3
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontWeight: 300,
              fontSize: "20px",
              lineHeight: "28px",
              color: "#404248",
              textAlign: "center",
              margin: "0 10px 40px 10px",
              maxWidth: "100%",
            }}
          >
            {intl.formatMessage({
              id: "questions.subheading",
              defaultMessage: "Because when it comes to health, every question matters",
            })}
          </h3>

          <div style={{ marginBottom: "32px" }}>
            {accordionItems.map((item, index) => (
              <div
                key={index}
                style={{
                  marginBottom: "12px",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  onClick={() => toggleAccordion(index)}
                  style={{
                    padding: "16px 20px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "#FFFFFF",
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#F9FAFB";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#FFFFFF";
                  }}
                >
                  <div
                    className={`questions-item-title ${
                      openIndex === index ? "questions-item-title--active" : ""
                    }`}
                    style={{
                      fontFamily: "Helvetica, Arial, sans-serif",
                      fontSize: "18px",
                      lineHeight: "26px",
                      color: openIndex === index ? "#00428A" : "#4A536A",
                      fontWeight: openIndex === index ? 600 : 400,
                      flex: 1,
                      paddingRight: "16px",
                    }}
                  >
                    {item.title}
                  </div>
                  <span
                    className={`questions-item-arrow ${
                      openIndex === index ? "questions-item-arrow--open" : ""
                    }`}
                  >
                    ▾
                  </span>
                </div>

                {openIndex === index && (
                  <div
                    style={{
                      padding: "16px 20px",
                      backgroundColor: "#F5F8FC",
                      fontFamily: "Helvetica, Arial, sans-serif",
                      fontSize: "16px",
                      lineHeight: "24px",
                      color: "#4A536A",
                    }}
                  >
                    {Array.isArray(item.content) ? (
                      item.content.map((paragraph, pIndex) => (
                        <p
                          key={pIndex}
                          style={{
                            margin: pIndex < item.content.length - 1 ? "0 0 12px 0" : "0",
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "8px",
                              lineHeight: "24px",
                            }}
                          >
                            •
                          </span>
                          <span>{paragraph}</span>
                        </p>
                      ))
                    ) : (
                      <p style={{ margin: 0 }}>{item.content}</p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="questions-cta-wrapper">
            <Link
              // onClick={()=>dispatch(openModal("Talk to the Fitsib team"))}
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="questions-cta"
            >
              <span>
                {intl.formatMessage({
                  id: "questions.cta",
                  defaultMessage: "Talk to the Fitsib team",
                })}
              </span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
